/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetGachaWithAltArtResponse } from '../../models/get-gacha-with-alt-art-response';

export interface GachaServiceGetGachaWithAltArt$Params {
  showStaging?: boolean;
}

export function gachaServiceGetGachaWithAltArt(http: HttpClient, rootUrl: string, params?: GachaServiceGetGachaWithAltArt$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGachaWithAltArtResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceGetGachaWithAltArt.PATH, 'get');
  if (params) {
    rb.query('showStaging', params.showStaging, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetGachaWithAltArtResponse>;
    })
  );
}

gachaServiceGetGachaWithAltArt.PATH = '/api/v3/gateway/gacha/altart/all';
